// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27120%27 height=%27120%27 viewBox=%270 0 120 120%27%3E%3Cpath fill=%27none%27 stroke=%27rgba%28182,255,58,0.12%29%27 stroke-width=%272%27 d=%27M0 60 Q30 20 60 60 T120 60%27/%3E%3Cpath fill=%27none%27 stroke=%27rgba%28255,255,255,0.06%29%27 stroke-width=%272%27 d=%27M0 80 Q30 40 60 80 T120 80%27/%3E%3Cpath fill=%27none%27 stroke=%27rgba%28255,255,255,0.05%29%27 stroke-width=%272%27 d=%27M0 40 Q30 0 60 40 T120 40%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --jh-bg: #0a0a0a;
  --jh-bg-2: #0e0e0e;
  --jh-surface: #141414;
  --jh-surface-2: #1d1d1d;
  --jh-line: rgba(244, 243, 236, 0.08);
  --jh-line-strong: rgba(244, 243, 236, 0.17);
  --jh-text: #f4f3ec;
  --jh-muted: #a5a5a1;
  --jh-accent: #b6ff3a;
  --jh-accent-soft: rgba(182, 255, 58, 0.14);
  --jh-accent-ink: #101503;
  --jh-accent-2: #22c55e;
  --jh-radius: 18px;
  --jh-radius-lg: 28px;
  --jh-photo-bg: transparent;
  --jh-font: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  --jh-font-display: "Fraunces", "Iowan Old Style", Georgia, serif;
  --jh-ease: cubic-bezier(0.16, 1, 0.3, 1);
  --jh-shadow-lift: 0 24px 48px -20px rgba(0, 0, 0, 0.7);
  --jh-glow-accent: 0 10px 32px rgba(182, 255, 58, 0.22);
  --jh-glow-accent-strong: 0 16px 44px rgba(182, 255, 58, 0.34);
}

::selection {
  background: rgba(182, 255, 58, 0.28);
  color: #fff;
}

:where(a, button, input, [tabindex]):focus-visible {
  outline: 2px solid var(--jh-accent);
  outline-offset: 2px;
  border-radius: 6px;
}

/* ---------- Typography helpers ---------- */
.jh-display {
  font-family: var(--jh-font-display);
  font-weight: 600;
  letter-spacing: -0.01em;
  font-variant-ligatures: common-ligatures;
}

.jh-hl {
  font-family: var(--jh-font-display);
  font-style: italic;
  font-weight: 600;
  color: var(--jh-accent);
}

.jh-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-family: var(--jh-font);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--jh-muted);
}

.jh-eyebrow .jh-dot,
.jh-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--jh-accent);
  box-shadow: 0 0 10px var(--jh-accent);
  flex-shrink: 0;
}

/* ---------- Buttons ---------- */
.jh-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1rem 1.7rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-family: var(--jh-font);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.01em;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.25s var(--jh-ease), box-shadow 0.25s ease, background 0.25s ease, border-color 0.25s ease, color 0.25s ease;
}

.jh-btn:active {
  transform: scale(0.97);
}

.jh-btn--primary {
  background: var(--jh-accent);
  color: var(--jh-accent-ink);
  box-shadow: var(--jh-glow-accent);
}

.jh-btn--primary::after {
  content: "";
  position: absolute;
  top: 0;
  left: -80%;
  width: 50%;
  height: 100%;
  background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s var(--jh-ease);
  pointer-events: none;
}

.jh-btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--jh-glow-accent-strong);
}

.jh-btn--primary:hover::after {
  left: 130%;
}

.jh-btn--primary:active {
  transform: scale(0.97);
}

.jh-btn--ghost {
  background: rgba(244, 243, 236, 0.04);
  color: var(--jh-text);
  border-color: var(--jh-line-strong);
  backdrop-filter: blur(6px);
}

.jh-btn--ghost:hover {
  transform: translateY(-2px);
  background: rgba(244, 243, 236, 0.09);
  border-color: rgba(244, 243, 236, 0.3);
}

/* ---------- Media frames (product imagery) ---------- */
.jh-photo-well {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--jh-photo-bg);
}

.jh-photo-well img {
  filter: none !important;
}

.jh-card-media {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  background: radial-gradient(80% 80% at 50% 30%, #1c1c1c, var(--jh-surface));
}

.jh-card-media__frame {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.jh-card-media--flower .jh-card-media__frame {
  inset: 1rem 1.15rem;
}

.jh-card-media--inventory .jh-card-media__frame {
  inset: 0.85rem;
  background: var(--jh-photo-bg);
  border-radius: 14px;
}

.jh-card-media__frame img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.jh-card-media--flower .jh-card-media__frame img {
  max-width: 88%;
  max-height: 88%;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.45));
}

.jh-card-media--inventory .jh-card-media__frame img {
  max-width: 94%;
  max-height: 94%;
  filter: none !important;
}

/* ---------- Scroll reveal ---------- */
.jh-reveal {
  opacity: 0;
  transform: translate3d(0, var(--jh-reveal-y, 28px), 0);
  transition: opacity var(--jh-reveal-dur, 800ms) var(--jh-reveal-ease, cubic-bezier(0.16, 1, 0.3, 1)), transform var(--jh-reveal-dur, 800ms) var(--jh-reveal-ease, cubic-bezier(0.16, 1, 0.3, 1));
  backface-visibility: hidden;
  will-change: opacity, transform;
}

.jh-reveal.jh-in {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  will-change: auto;
}

.jh-accent-text {
  color: var(--jh-accent);
}

/* ---------- Background patterns ---------- */
.jh-pattern {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.jh-pattern-dots {
  background-color: var(--jh-surface);
  background-image: radial-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 12px 12px;
}

.jh-pattern-flower {
  background-color: #111111;
  background-image: radial-gradient(rgba(255, 255, 255, 0.075) 1px, transparent 1px);
  background-size: 10px 10px;
}

.jh-pattern-stripes {
  background-color: var(--jh-surface);
  background-image: repeating-linear-gradient(-42deg, transparent 0, transparent 14px, rgba(255, 255, 255, 0.045) 14px, rgba(255, 255, 255, 0.045) 28px);
}

.jh-pattern-sunburst {
  background-color: #151515;
  background-image: radial-gradient(circle at 28% 32%, rgba(182, 255, 58, 0.14), transparent 42%), repeating-conic-gradient(from 0deg at 50% 45%, transparent 0deg 10deg, rgba(255, 255, 255, 0.035) 10deg 20deg);
}

.jh-pattern-waves {
  background-color: var(--jh-surface);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 140px 140px;
}

.jh-pattern-cross {
  background-color: var(--jh-surface);
  background-image: radial-gradient(rgba(182, 255, 58, 0.2) 1.5px, transparent 1.5px), linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 22px 22px, 22px 22px, 22px 22px;
}

.jh-pattern-corner {
  background-color: var(--jh-surface);
  background-image: linear-gradient(125deg, transparent 55%, rgba(182, 255, 58, 0.12) 55%, rgba(182, 255, 58, 0.04) 72%, transparent 72%), repeating-linear-gradient(-24deg, transparent 0, transparent 18px, rgba(255, 255, 255, 0.05) 18px, rgba(255, 255, 255, 0.05) 19px);
}

.jh-pattern-blob {
  background-color: var(--jh-surface);
  background-image: radial-gradient(ellipse 90% 80% at 105% -5%, rgba(182, 255, 58, 0.2), transparent 52%), radial-gradient(ellipse 70% 60% at -5% 105%, rgba(255, 255, 255, 0.08), transparent 48%);
}

.jh-pattern-grid {
  background-color: var(--jh-surface);
  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 18px 18px;
}

@media (prefers-reduced-motion: reduce) {
  .jh-reveal {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }
  .jh-btn,
  .jh-btn::after {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/storefront.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oCAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,uGAAA;EACA,gEAAA;EACA,wCAAA;EACA,sDAAA;EACA,sDAAA;EACA,6DAAA;AACJ;;AAEA;EACI,oCAAA;EACA,WAAA;AACJ;;AAEA;EACI,mCAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA,6CAAA;AAEA;EACI,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;AAAJ;;AAGA;EACI,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAAJ;;AAGA;;EAEI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,qCAAA;EACA,cAAA;AAAJ;;AAGA,kCAAA;AAEA;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mIAAA;AADJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,2BAAA;EACA,iCAAA;AAFJ;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,uFAAA;EACA,wBAAA;EACA,oCAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,2BAAA;EACA,wCAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,qCAAA;EACA,qBAAA;EACA,mCAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,2BAAA;EACA,qCAAA;EACA,sCAAA;AAFJ;;AAKA,yDAAA;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,uBAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,2EAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,eAAA;EACA,oDAAA;AAHJ;;AAMA;EACI,cAAA;EACA,eAAA;EACA,uBAAA;AAHJ;;AAMA,wCAAA;AAEA;EACI,UAAA;EACA,sDAAA;EACA,gMACI;EAEJ,2BAAA;EACA,+BAAA;AANJ;;AASA;EACI,UAAA;EACA,+BAAA;EACA,iBAAA;AANJ;;AASA;EACI,uBAAA;AANJ;;AASA,8CAAA;AAEA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,mCAAA;EACA,gFAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,yBAAA;EACA,kFAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,mCAAA;EACA,sJAAA;AAPJ;;AAgBA;EACI,yBAAA;EACA,+MACI;AAdR;;AAsBA;EACI,mCAAA;EACA,yDAAA;EACA,4BAAA;AAnBJ;;AAsBA;EACI,mCAAA;EACA,4NACI;EAGJ,gDAAA;AAtBJ;;AAyBA;EACI,mCAAA;EACA,2QACI;AAvBR;;AAiCA;EACI,mCAAA;EACA,kMACI;AA/BR;;AAmCA;EACI,mCAAA;EACA,yJACI;EAEJ,0BAAA;AAlCJ;;AAqCA;EACI;IACI,qBAAA;IACA,0BAAA;IACA,2BAAA;EAlCN;EAqCE;;IAEI,2BAAA;EAnCN;AACF","sourcesContent":[":root {\n    --jh-bg: #0a0a0a;\n    --jh-bg-2: #0e0e0e;\n    --jh-surface: #141414;\n    --jh-surface-2: #1d1d1d;\n    --jh-line: rgba(244, 243, 236, 0.08);\n    --jh-line-strong: rgba(244, 243, 236, 0.17);\n    --jh-text: #f4f3ec;\n    --jh-muted: #a5a5a1;\n    --jh-accent: #b6ff3a;\n    --jh-accent-soft: rgba(182, 255, 58, 0.14);\n    --jh-accent-ink: #101503;\n    --jh-accent-2: #22c55e;\n    --jh-radius: 18px;\n    --jh-radius-lg: 28px;\n    --jh-photo-bg: transparent;\n    --jh-font: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    --jh-font-display: \"Fraunces\", \"Iowan Old Style\", Georgia, serif;\n    --jh-ease: cubic-bezier(0.16, 1, 0.3, 1);\n    --jh-shadow-lift: 0 24px 48px -20px rgba(0, 0, 0, 0.7);\n    --jh-glow-accent: 0 10px 32px rgba(182, 255, 58, 0.22);\n    --jh-glow-accent-strong: 0 16px 44px rgba(182, 255, 58, 0.34);\n}\n\n::selection {\n    background: rgba(182, 255, 58, 0.28);\n    color: #fff;\n}\n\n:where(a, button, input, [tabindex]):focus-visible {\n    outline: 2px solid var(--jh-accent);\n    outline-offset: 2px;\n    border-radius: 6px;\n}\n\n/* ---------- Typography helpers ---------- */\n\n.jh-display {\n    font-family: var(--jh-font-display);\n    font-weight: 600;\n    letter-spacing: -0.01em;\n    font-variant-ligatures: common-ligatures;\n}\n\n.jh-hl {\n    font-family: var(--jh-font-display);\n    font-style: italic;\n    font-weight: 600;\n    color: var(--jh-accent);\n}\n\n.jh-eyebrow {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.55rem;\n    font-family: var(--jh-font);\n    font-size: 0.78rem;\n    font-weight: 600;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: var(--jh-muted);\n}\n\n.jh-eyebrow .jh-dot,\n.jh-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: var(--jh-accent);\n    box-shadow: 0 0 10px var(--jh-accent);\n    flex-shrink: 0;\n}\n\n/* ---------- Buttons ---------- */\n\n.jh-btn {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    padding: 1rem 1.7rem;\n    border-radius: 999px;\n    border: 1px solid transparent;\n    font-family: var(--jh-font);\n    font-weight: 700;\n    font-size: 1rem;\n    letter-spacing: 0.01em;\n    text-decoration: none;\n    cursor: pointer;\n    overflow: hidden;\n    transition: transform 0.25s var(--jh-ease), box-shadow 0.25s ease, background 0.25s ease,\n        border-color 0.25s ease, color 0.25s ease;\n}\n\n.jh-btn:active {\n    transform: scale(0.97);\n}\n\n.jh-btn--primary {\n    background: var(--jh-accent);\n    color: var(--jh-accent-ink);\n    box-shadow: var(--jh-glow-accent);\n}\n\n.jh-btn--primary::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -80%;\n    width: 50%;\n    height: 100%;\n    background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n    transform: skewX(-20deg);\n    transition: left 0.6s var(--jh-ease);\n    pointer-events: none;\n}\n\n.jh-btn--primary:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--jh-glow-accent-strong);\n}\n\n.jh-btn--primary:hover::after {\n    left: 130%;\n}\n\n.jh-btn--primary:active {\n    transform: scale(0.97);\n}\n\n.jh-btn--ghost {\n    background: rgba(244, 243, 236, 0.04);\n    color: var(--jh-text);\n    border-color: var(--jh-line-strong);\n    backdrop-filter: blur(6px);\n}\n\n.jh-btn--ghost:hover {\n    transform: translateY(-2px);\n    background: rgba(244, 243, 236, 0.09);\n    border-color: rgba(244, 243, 236, 0.3);\n}\n\n/* ---------- Media frames (product imagery) ---------- */\n\n.jh-photo-well {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--jh-photo-bg);\n}\n\n.jh-photo-well img {\n    filter: none !important;\n}\n\n.jh-card-media {\n    position: relative;\n    flex-shrink: 0;\n    overflow: hidden;\n    background: radial-gradient(80% 80% at 50% 30%, #1c1c1c, var(--jh-surface));\n}\n\n.jh-card-media__frame {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.jh-card-media--flower .jh-card-media__frame {\n    inset: 1rem 1.15rem;\n}\n\n.jh-card-media--inventory .jh-card-media__frame {\n    inset: 0.85rem;\n    background: var(--jh-photo-bg);\n    border-radius: 14px;\n}\n\n.jh-card-media__frame img {\n    display: block;\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n}\n\n.jh-card-media--flower .jh-card-media__frame img {\n    max-width: 88%;\n    max-height: 88%;\n    filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.45));\n}\n\n.jh-card-media--inventory .jh-card-media__frame img {\n    max-width: 94%;\n    max-height: 94%;\n    filter: none !important;\n}\n\n/* ---------- Scroll reveal ---------- */\n\n.jh-reveal {\n    opacity: 0;\n    transform: translate3d(0, var(--jh-reveal-y, 28px), 0);\n    transition:\n        opacity var(--jh-reveal-dur, 800ms) var(--jh-reveal-ease, cubic-bezier(0.16, 1, 0.3, 1)),\n        transform var(--jh-reveal-dur, 800ms) var(--jh-reveal-ease, cubic-bezier(0.16, 1, 0.3, 1));\n    backface-visibility: hidden;\n    will-change: opacity, transform;\n}\n\n.jh-reveal.jh-in {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n    will-change: auto;\n}\n\n.jh-accent-text {\n    color: var(--jh-accent);\n}\n\n/* ---------- Background patterns ---------- */\n\n.jh-pattern {\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n    pointer-events: none;\n}\n\n.jh-pattern-dots {\n    background-color: var(--jh-surface);\n    background-image: radial-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px);\n    background-size: 12px 12px;\n}\n\n.jh-pattern-flower {\n    background-color: #111111;\n    background-image: radial-gradient(rgba(255, 255, 255, 0.075) 1px, transparent 1px);\n    background-size: 10px 10px;\n}\n\n.jh-pattern-stripes {\n    background-color: var(--jh-surface);\n    background-image: repeating-linear-gradient(\n        -42deg,\n        transparent 0,\n        transparent 14px,\n        rgba(255, 255, 255, 0.045) 14px,\n        rgba(255, 255, 255, 0.045) 28px\n    );\n}\n\n.jh-pattern-sunburst {\n    background-color: #151515;\n    background-image:\n        radial-gradient(circle at 28% 32%, rgba(182, 255, 58, 0.14), transparent 42%),\n        repeating-conic-gradient(\n            from 0deg at 50% 45%,\n            transparent 0deg 10deg,\n            rgba(255, 255, 255, 0.035) 10deg 20deg\n        );\n}\n\n.jh-pattern-waves {\n    background-color: var(--jh-surface);\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Cpath fill='none' stroke='rgba(182,255,58,0.12)' stroke-width='2' d='M0 60 Q30 20 60 60 T120 60'/%3E%3Cpath fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='2' d='M0 80 Q30 40 60 80 T120 80'/%3E%3Cpath fill='none' stroke='rgba(255,255,255,0.05)' stroke-width='2' d='M0 40 Q30 0 60 40 T120 40'/%3E%3C/svg%3E\");\n    background-size: 140px 140px;\n}\n\n.jh-pattern-cross {\n    background-color: var(--jh-surface);\n    background-image:\n        radial-gradient(rgba(182, 255, 58, 0.2) 1.5px, transparent 1.5px),\n        linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);\n    background-size: 22px 22px, 22px 22px, 22px 22px;\n}\n\n.jh-pattern-corner {\n    background-color: var(--jh-surface);\n    background-image:\n        linear-gradient(125deg, transparent 55%, rgba(182, 255, 58, 0.12) 55%, rgba(182, 255, 58, 0.04) 72%, transparent 72%),\n        repeating-linear-gradient(\n            -24deg,\n            transparent 0,\n            transparent 18px,\n            rgba(255, 255, 255, 0.05) 18px,\n            rgba(255, 255, 255, 0.05) 19px\n        );\n}\n\n.jh-pattern-blob {\n    background-color: var(--jh-surface);\n    background-image:\n        radial-gradient(ellipse 90% 80% at 105% -5%, rgba(182, 255, 58, 0.2), transparent 52%),\n        radial-gradient(ellipse 70% 60% at -5% 105%, rgba(255, 255, 255, 0.08), transparent 48%);\n}\n\n.jh-pattern-grid {\n    background-color: var(--jh-surface);\n    background-image:\n        linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n    background-size: 18px 18px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .jh-reveal {\n        opacity: 1 !important;\n        transform: none !important;\n        transition: none !important;\n    }\n\n    .jh-btn,\n    .jh-btn::after {\n        transition: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
